<template>
  <v-data-table :headers="headers"
                :items="sessions"
                :items-per-page="itemsPerPage"
                :footer-props="{'items-per-page-options': [50, 100, 500, 1000]}"
                :loading="loading"
                :dense="dense">
    <template v-slot:item.userContact.name="{item: session}">
      <template v-if="session.userContact && session.userContact.name">
        {{ session.userContact.name }}
      </template>
      <template v-else>
        Unknown
      </template>
    </template>
    <template v-slot:item.started_at="{item: session}">
      {{ session.started_at | datetime('MMM D, YYYY h:mm a') }}
    </template>
    <template v-slot:item.duration="{item: session}">
      {{ session.duration_time }}
    </template>
    <template v-slot:item.actions="{item: session}">
      <v-btn v-if="$root.isAdminRoute"
             :to="{name: 'admin.sharing_session.show', params: {presentationID: session.presentation_id, sessionID: session.id}}">
        <v-icon>
          fal fa-chart-bar
        </v-icon>
      </v-btn>
      <v-btn v-else
             :to="{name: `${$root.routePrefix}.session.show`, params: {sessionID: session.id}}"
             small>
        <v-icon>
          fal fa-chart-bar
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:item.num_pages_viewed="{item: session}">
      {{ session.num_pages_viewed }} / {{ session.num_pages }}
    </template>
    <template v-slot:item.percent_viewed="{item: session}">
      <percent-viewed-donut :percent-viewed="session.percent_viewed"
                            :size="36">
      </percent-viewed-donut>
    </template>
  </v-data-table>
</template>
<script>

import PercentViewedDonut from './PercentViewedDonut';

export default {
  components: {PercentViewedDonut},
  props: {
    dense: {
      type: Boolean,
      default: false,
    },
    itemsPerPage: {
      type: Number,
      default: 5,
    },
    sessions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    headers() {
      if (this.$root.isAdminRoute) {
        return [
          {text: '', value: 'actions', sortable: false, width: '80px'},
          {text: 'User', value: 'user.name', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Name', value: 'userContact.name', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Email', value: 'userContact.email', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'When', value: 'started_at', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Duration', value: 'duration', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Pages Viewed', value: 'num_pages_viewed', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Percent Viewed', value: 'percent_viewed', sortable: true, cellClass: 'text-no-wrap'},
        ]
      } else {
        return [
          {text: '', value: 'actions', sortable: false, width: '80px'},
          {text: 'Contact Name', value: 'userContact.name', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Email', value: 'userContact.email', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'When', value: 'started_at', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Duration', value: 'duration', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Pages Viewed', value: 'num_pages_viewed', sortable: true, cellClass: 'text-no-wrap'},
          {text: 'Percent Viewed', value: 'percent_viewed', sortable: true, cellClass: 'text-no-wrap'},
        ]
      }
    }
  }
}
</script>
